import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { ReviewSolutionImageStoreModel } from './review-solution-image.model';

export interface ReviewSolutionImageState extends EntityState<ReviewSolutionImageStoreModel> {}

@Injectable({ providedIn: 'root' })
export class ReviewSolutionImageStore extends EntityStore<
  ReviewSolutionImageState,
  ReviewSolutionImageStoreModel,
  'id'
> {
  constructor() {
    super({
      name: 'review-solution-images',
      idKey: 'id',
    });
  }
}
